import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { FullCalendarModule } from "@fullcalendar/angular";
import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbModule,
  NgbNavModule,
  NgbPaginationModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { NgApexchartsModule } from "ng-apexcharts";
import { LightboxModule } from "ngx-lightbox";
import { CarouselModule } from "ngx-owl-carousel-o";
import { SimplebarAngularModule } from "simplebar-angular";
import { UIModule } from "../../shared/ui/ui.module";
import { WidgetModule } from "../../shared/widget/widget.module";

import { LiveCardComponent } from "./live-card/live-card.component";
import { NetSaleComponent } from "./net-sale/net-sale.component";
import { StarterRoutingModule } from './starter-routing.module';
import { StarterComponent } from "./starter.component";
// import { CoursesComponent } from './menu/courses/courses.component';
import { AgmCoreModule } from "@agm/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ChartsModule } from "ng2-charts";
import { Daterangepicker } from "ng2-daterangepicker";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { NgxEchartsModule } from "ngx-echarts";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { NgxPaginationModule } from "ngx-pagination";
import { UiSwitchModule } from "ngx-ui-switch";
import { environment } from 'src/environments/environment';
import { CoreModule } from "../../core/core.module";
import { LabourRoutingModule } from "../reports/labour/labour-routing.module";
import { AdminOverviewComponent } from "./admin-overview/admin-overview.component";
import { AllLinksDemoComponent } from './all-links-demo/all-links-demo.component';
import { DashboardReportComponent } from "./dashboard-report/dashboard-report.component";
import { LakhSeparatorPipe } from "./lakhspipe";
import { NetworkOverviewComponent } from "./networkOverview/network-overview.component";
import { OverallInsightsComponent } from "./overall-insights/overall-insights.component";

// import { AllLinksDemoComponent } from './all-links-demo/all-links-demo.component';
import { ReferEarnComponent } from "./refer-earn.component";
import { ReferStaticsComponent } from './refer-statics/refer-statics.component';
import { DataTablesModule } from 'angular-datatables';
import { ReferStaticsAdminComponent } from './refer-statics-admin/refer-statics-admin.component';


@NgModule({
  declarations: [
    LiveCardComponent,
    NetSaleComponent,
    DashboardReportComponent,
    StarterComponent,
    LakhSeparatorPipe,
    OverallInsightsComponent,
    AdminOverviewComponent,
    NetworkOverviewComponent,
    AllLinksDemoComponent,
    ReferEarnComponent,
    ReferStaticsComponent,
    ReferStaticsAdminComponent,
  ],
  imports: [
    CommonModule,
    NgbAccordionModule,
    StarterRoutingModule,
    CarouselModule,
    CommonModule,
    FormsModule,
    NgbDropdownModule,
    NgbModalModule,
    NgbNavModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    // HttpClientModule,
    UIModule,
    WidgetModule,
    FullCalendarModule,
    NgbNavModule,
    NgbModule,
    NgbTooltipModule,
    NgbCollapseModule,
    SimplebarAngularModule,
    LightboxModule,
    NgxDaterangepickerMd.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    Daterangepicker,
    NgbPopoverModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    NgbAccordionModule,
    Daterangepicker,
    CommonModule,
    LabourRoutingModule,
    NgbNavModule,
    NgbDropdownModule,
    NgApexchartsModule,
    NgbAccordionModule,
    NgbPaginationModule,
    NgSelectModule,
    NgMultiSelectDropDownModule,
    NgxPaginationModule,
    UIModule,
    FormsModule,
    ReactiveFormsModule,
    NgbPopoverModule,
    UiSwitchModule,
    NgxIntlTelInputModule,
    CoreModule,
    ChartsModule,
    DataTablesModule,
    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    }),
    AgmCoreModule.forRoot({
      apiKey: environment.googleApiKey,
      libraries: ["places"],
    })
  ],
  exports: [
    StarterComponent // <--- Enable using the component in other modules
  ]
})
export class StarterModule { }
